import { PureComponent } from 'react';
import { remove, forEach } from 'lodash-es';
import { ScrollContext } from 'hocs/WithScroll';
import Scrollbar from './Scrollbar';

import { animateScroll } from './utils';

class Scroll extends PureComponent {
  listeners = {
    scroll: [],
    scrollStop: [],
  };

  width = {
    normal: 12,
    thin: 6,
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.path &&
      this.props.path.split('/')[1] !== prevProps.path.split('/')[1]
    ) {
      this.scrollTo(0);
    }
  }

  handleScrollRef = (ref) => {
    this.scrollbar = ref;
  };

  addListener = (event, listener) => {
    this.listeners[event].push(listener);
  };

  removeListener = (event, listener) => {
    remove(this.listeners[event], (item) => item === listener);
  };

  fireEvents(evt, payload) {
    forEach(this.listeners[evt], (event) => event(payload));
  }

  scrollTo = (pos = 0) => {
    this.scrollbar.scrollTop(pos);
  };

  getScrollTop = () => this.scrollbar.getScrollTop();

  getScrollHeight = () => this.scrollbar.getScrollHeight();

  getClientHeight = () => this.scrollbar.getClientHeight();

  scrollToAnimated = (top, options) => {
    animateScroll(top, options, this.scrollbar);
  };

  triggerScrolling = (position = 0, isAnimated = false) => {
    setTimeout(
      () =>
        isAnimated ? this.scrollToAnimated(position) : this.scrollTo(position),
      0
    );
  };

  updateScroll = () => {
    setTimeout(() => this.scrollbar.update(), 0);
  };

  handleScroll = () => {
    const top = this.scrollbar.getScrollTop();
    this.fireEvents('scroll', top);
    this.props.onScroll && this.props.onScroll(top);
  };

  handleScrollStop = () => {
    const top = this.scrollbar.getScrollTop();
    this.fireEvents('scrollStop', top);
    this.props.onScrollStop && this.props.onScrollStop();
  };

  render() {
    const { viewClassName, containerClassName, type = 'normal' } = this.props;

    return (
      <Scrollbar
        ref={this.handleScrollRef}
        onScroll={this.handleScroll}
        onScrollStop={this.handleScrollStop}
        width={this.width[type]}
        viewClassName={viewClassName}
        containerClassName={containerClassName}
      >
        <ScrollContext.Provider
          value={{
            getScrollTop: this.getScrollTop,
            triggerScrolling: this.triggerScrolling,
            addListener: this.addListener,
            removeListener: this.removeListener,
            update: this.updateScroll,
            scrollTo: this.scrollTo,
          }}
        >
          {this.props.children}
        </ScrollContext.Provider>
      </Scrollbar>
    );
  }
}

export default Scroll;
